import { BuyList } from 'types'

export const EMPTY_BUY_LIST_STATE: BuyList = {
  id: '',
  displayName: '',
  assets: [],
}

export const MINIMUM_BUY_LIST_LENGTH = 20
